import React from 'react';
import { FaChevronDown, FaTags, FaFilter } from 'react-icons/fa';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { COLORS, TREE_CHART_MODES } from '../../../../constants/radar';
import {
  PanelContainer,
  PanelContent,
  ToggleContainer,
  ToggleButton,
  NavigationRow,
  Controls,
  CollapsedContent,
  Label,
  CollapsedPath,
  BreadcrumbContainer,
  Divider,
  TagSelectButton,
  TagIcon,
  TagCount,
  FilterButton,
  FilterIcon,
  FilterStatus,
} from './styles';

const NavigationPanel = ({
  isExpanded,
  onToggle,
  searchBar,
  breadcrumb,
  isVisible,
  onTagSelect,
  selectedTagsCount,
  configMode,
  showOnlySelected,
  onToggleShowSelected,
  chartType,
  selectedCount,
}) => {
  const breadcrumbPath = useBreadcrumb(
    breadcrumb.props.data,
    breadcrumb.props.selectedSubcategory
  );

  const pathString = breadcrumbPath.length > 0 
    ? breadcrumbPath.map(item => item.name || 'All').join(' > ')
    : '';

  return (
    <PanelContainer $isExpanded={isExpanded} $isVisible={isVisible}>
      {isExpanded ? (
        <>
          <Controls>
            <NavigationRow>
              {searchBar}
              {(configMode === TREE_CHART_MODES.PROJECT || 
                configMode === TREE_CHART_MODES.DASHBOARD ||
                configMode === TREE_CHART_MODES.EMPLOYEE) && 
               chartType === TREE_CHART_MODES.TREE && (
                <FilterButton 
                  onClick={onToggleShowSelected}
                  $isActive={showOnlySelected}
                >
                  <FilterIcon>
                    <FaFilter />
                  </FilterIcon>
                  {showOnlySelected ? 'Showing Selected' : 'Showing All'}
                  <FilterStatus $isActive={showOnlySelected}>
                    {showOnlySelected ? `(${selectedCount} items)` : ''}
                  </FilterStatus>
                </FilterButton>
              )}
              <TagSelectButton 
                onClick={onTagSelect}
                $hasSelectedTags={selectedTagsCount > 0}
              >
                <TagIcon>
                  <FaTags />
                </TagIcon>
                {selectedTagsCount > 0 ? 'Tags Selected' : 'Select Tags'}
                {selectedTagsCount > 0 && (
                  <TagCount>
                    {selectedTagsCount}
                  </TagCount>
                )}
              </TagSelectButton>
            </NavigationRow>
          </Controls>
          <Divider />
          <PanelContent $isExpanded={isExpanded}>
            <BreadcrumbContainer>
              <Label>Navigation:</Label>
              {breadcrumb}
            </BreadcrumbContainer>
          </PanelContent>
          <ToggleContainer>
            <ToggleButton onClick={onToggle} $isExpanded={isExpanded}>
              <FaChevronDown />
            </ToggleButton>
          </ToggleContainer>
        </>
      ) : (
        <CollapsedContent>
          <div>
            <Label>Navigation</Label>
            {pathString && (
              <CollapsedPath>
                {pathString}
              </CollapsedPath>
            )}
          </div>
          <ToggleButton onClick={onToggle} $isExpanded={isExpanded}>
            <FaChevronDown />
          </ToggleButton>
        </CollapsedContent>
      )}
    </PanelContainer>
  );
};

export default NavigationPanel; 